import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { CustomModal } from "../components/CustomModal";
import { Icon } from "@mui/material";
import { API_URL } from "../api";

export default function FormObservation() {
    const navigate = useNavigate();
    const [step, setStep] = useState(1);
    const [activeTab, setActiveTab] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Modal State
    const [modalVisible, setModalVisible] = useState(false);
    const [modalProps, setModalProps] = useState({
        title: "",
        message: "",
        type: "info",
        buttons: []
    });

    // Signature Canvas Refs
    const observerCanvasRef = useRef(null);
    const observedCanvasRef = useRef(null);
    const [isDrawing, setIsDrawing] = useState(false);

    // Form Data
    const [formData, setFormData] = useState({

        lokasi: "",
        department: "",
        tanggal: "",
        kegiatan: "",
        observerName: "",
        observedPersonName: "",


        responses: {},


        actions: [{ description: "" }],
        recommendations: [{ description: "" }],
        supervisorComment: "",
        supervisorName: "",


        observerSignature: "",
        observedSignature: ""
    });


    const observationSections = [
        {
            id: 1,
            title: "SOP/SEP/Work Method/JSA",
            questions: [
                { no: "1.1", text: "SOP/SEP/Work Method/JSA is available - Tersedia Prosedur/Standar/Instruksi Kerja/JSA" },
                { no: "1.2", text: "SOP/SEP/Work Method/JSA is understood - Prosedur/Standar/Instruksi Kerja/JSA dimengerti" },
                { no: "1.3", text: "SOP/SEP/Work Method/JSA is implemented - Prosedur/Standar/Instruksi Kerja/JSA dilaksanakan" }
            ]
        },
        {
            id: 2,
            title: "PPE/Alat Pelindung Diri (APD)",
            questions: [
                { no: "2.1a", text: "Kepala (Safety Helmet)" },
                { no: "2.1b", text: "Mata (Safety Glass)" },
                { no: "2.2a", text: "Muka (Face Shield)" },
                { no: "2.2b", text: "Telinga (Ear Plug)" },
                { no: "2.3", text: "Alat Pernafasan (Respiratory)" },
                { no: "2.4", text: "Tangan (Hand Gloves)" },
                { no: "2.5a", text: "Badan (Apron, Vest)" },
                { no: "2.5b", text: "Kaki (Safety Shoes)" },
                { no: "2.6", text: "Alat Pelindung Jatuh (Full Body Harness)" }
            ]
        },
        {
            id: 3,
            title: "Posisi Orang",
            questions: [
                { no: "3.1", text: "Terpeleset" },
                { no: "3.2", text: "Terpukul, Terbentur, Tertabrak" },
                { no: "3.3a", text: "Menghirup" },
                { no: "3.3b", text: "Menyerap" },
                { no: "3.3c", text: "Menelan" },
                { no: "3.4", text: "Terlalu memforsir tenaga" },
                { no: "3.5", text: "Posisi Lainnya" }
            ]
        },
        {
            id: 4,
            title: "Alat dan Peralatan",
            questions: [
                { no: "4.1", text: "Alat dan Peralatan sesuai dengan pekerjaan" },
                { no: "4.2", text: "Alat dan Peralatan digunakan dengan benar" },
                { no: "4.3", text: "Alat dan Peralatan dalam kondisi aman" }
            ]
        }
    ];

    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            const userData = JSON.parse(storedUser);
            setFormData(prev => ({
                ...prev,
                observerName: userData.nama || ""
            }));
        }
        const today = new Date().toISOString().split('T')[0];
        setFormData(prev => ({ ...prev, tanggal: today }));
    }, []);

    // Initialize signature canvases
    useEffect(() => {
        if (step === 4) {
            initCanvas(observerCanvasRef.current);
            initCanvas(observedCanvasRef.current);
        }
    }, [step]);

    const initCanvas = (canvas) => {
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.strokeStyle = '#000';
        ctx.lineWidth = 2;
        ctx.lineCap = 'round';
    };

    const showModal = (title, message, type = "info", buttons = []) => {
        setModalProps({ title, message, type, buttons });
        setModalVisible(true);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleResponseChange = (questionNo, jawaban) => {
        setFormData(prev => {
            const currentJawaban = prev.responses[questionNo]?.jawaban;


            if (currentJawaban === jawaban) {
                const newResponses = { ...prev.responses };
                delete newResponses[questionNo];
                return {
                    ...prev,
                    responses: newResponses
                };
            }


            return {
                ...prev,
                responses: {
                    ...prev.responses,
                    [questionNo]: {
                        jawaban,
                        keterangan: jawaban !== "Unsafe" ? "" : (prev.responses[questionNo]?.keterangan || "")
                    }
                }
            };
        });
    };

    const handleKeteranganChange = (questionNo, keterangan) => {
        setFormData(prev => ({
            ...prev,
            responses: {
                ...prev.responses,
                [questionNo]: {
                    ...prev.responses[questionNo],
                    keterangan
                }
            }
        }));
    };

    // Dynamic Lists Handlers
    const addAction = () => {
        setFormData(prev => ({
            ...prev,
            actions: [...prev.actions, { description: "" }]
        }));
    };

    const removeAction = (index) => {
        setFormData(prev => ({
            ...prev,
            actions: prev.actions.filter((_, i) => i !== index)
        }));
    };

    const updateAction = (index, value) => {
        const newActions = [...formData.actions];
        newActions[index].description = value;
        setFormData(prev => ({ ...prev, actions: newActions }));
    };

    const addRecommendation = () => {
        setFormData(prev => ({
            ...prev,
            recommendations: [...prev.recommendations, { description: "" }]
        }));
    };

    const removeRecommendation = (index) => {
        setFormData(prev => ({
            ...prev,
            recommendations: prev.recommendations.filter((_, i) => i !== index)
        }));
    };

    const updateRecommendation = (index, value) => {
        const newRecs = [...formData.recommendations];
        newRecs[index].description = value;
        setFormData(prev => ({ ...prev, recommendations: newRecs }));
    };

    // File Upload Handler
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData(prev => ({ ...prev, file }));
        }
    };

    // Signature Canvas Handlers
    const startDrawing = (e, canvasRef) => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        setIsDrawing(true);
        const ctx = canvas.getContext('2d');
        const rect = canvas.getBoundingClientRect();
        const x = (e.clientX || e.touches?.[0]?.clientX) - rect.left;
        const y = (e.clientY || e.touches?.[0]?.clientY) - rect.top;
        ctx.beginPath();
        ctx.moveTo(x, y);
    };

    const draw = (e, canvasRef) => {
        if (!isDrawing) return;
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        const rect = canvas.getBoundingClientRect();
        const x = (e.clientX || e.touches?.[0]?.clientX) - rect.left;
        const y = (e.clientY || e.touches?.[0]?.clientY) - rect.top;
        ctx.lineTo(x, y);
        ctx.stroke();
    };

    const stopDrawing = (canvasRef, signatureType) => {
        setIsDrawing(false);
        const canvas = canvasRef.current;
        if (!canvas) return;

        const dataUrl = canvas.toDataURL('image/png');
        setFormData(prev => ({
            ...prev,
            [signatureType]: dataUrl
        }));
    };

    const clearSignature = (canvasRef, signatureType) => {
        initCanvas(canvasRef.current);
        setFormData(prev => ({ ...prev, [signatureType]: "" }));
    };

    // Validation Functions
    const validateStep1 = () => {
        const { lokasi, department, tanggal, kegiatan, observerName, observedPersonName } = formData;
        if (!lokasi || !department || !tanggal || !kegiatan || !observerName || !observedPersonName) {
            showModal("Perhatian", "Mohon lengkapi semua field yang diperlukan", "warning");
            return false;
        }
        return true;
    };

    const validateStep2 = () => {
        for (const section of observationSections) {
            for (const q of section.questions) {
                const response = formData.responses[q.no];
                if (response?.jawaban === "Unsafe" && !response?.keterangan?.trim()) {
                    showModal("Perhatian", `Keterangan wajib diisi untuk jawaban "Unsafe" pada pertanyaan ${q.no}`, "warning");
                    return false;
                }
            }
        }
        return true;
    };

    const validateStep3 = () => {
        if (!formData.supervisorName?.trim()) {
            showModal("Perhatian", "Mohon isi nama supervisor", "warning");
            return false;
        }
        return true;
    };

    const nextStep = () => {
        if (step === 1 && !validateStep1()) return;
        if (step === 2 && !validateStep2()) return;
        if (step === 3 && !validateStep3()) return;
        setStep(step + 1);
    };

    const prevStep = () => setStep(step - 1);

    // Build responses for API
    const buildResponses = () => {
        const responses = [];
        for (const section of observationSections) {
            for (const q of section.questions) {
                const response = formData.responses[q.no];
                if (response?.jawaban) {
                    responses.push({
                        section: section.title,
                        no_pertanyaan: q.no,
                        pertanyaan: q.text,
                        jawaban: response.jawaban,
                        keterangan: response.keterangan || null
                    });
                }
            }
        }
        return responses;
    };

    const buildActions = () => {
        const actionsData = [];

        formData.actions.forEach(action => {
            if (action.description.trim()) {
                actionsData.push({
                    type: "ACTION",
                    description: action.description
                });
            }
        });

        formData.recommendations.forEach(rec => {
            if (rec.description.trim()) {
                actionsData.push({
                    type: "RECOMMENDATION",
                    description: rec.description
                });
            }
        });

        return actionsData;
    };

    const getResponseStats = () => {
        let safe = 0, unsafe = 0, na = 0;
        Object.values(formData.responses).forEach(r => {
            if (r.jawaban === "Safe") safe++;
            else if (r.jawaban === "Unsafe") unsafe++;
            else if (r.jawaban === "NA") na++;
        });
        return { safe, unsafe, na };
    };

    const handleSubmit = async () => {
        setIsSubmitting(true);


        try {
            const submitData = {
                lokasi: formData.lokasi,
                department: formData.department,
                tanggal: formData.tanggal,
                kegiatan: formData.kegiatan,
                observer_name: formData.observerName,
                observesed_person_name: formData.observedPersonName,
                supervisor_coment: formData.supervisorComment,
                supervisor_name: formData.supervisorName,
                responses: buildResponses(),
                actions: buildActions(),
                observer_signature: formData.observerSignature,
                observed_person_signature: formData.observedSignature
            };

            const token = localStorage.getItem("userToken");
            const response = await axios.post(
                `${API_URL}/observation-reports`,
                submitData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    }
                }
            );

            if (response.data.success) {
                showModal(
                    "Berhasil!",
                    "Laporan Observasi telah disimpan",
                    "success",
                    [{
                        text: "OK",
                        onPress: () => navigate("/laporan-safety")
                    }]
                );
            } else {
                showModal("Error", response.data.message || "Gagal menyimpan laporan", "error");
            }
        } catch (error) {
            console.error("Error submitting observation report:", error);
            const errorMessage = error.response?.data?.message || "Terjadi kesalahan saat menyimpan laporan";
            showModal("Error", errorMessage, "error");
        } finally {
            setIsSubmitting(false);
        }

    };

    const stats = getResponseStats();

    return (
        <div>
            {/* Header */}
            <header className="app-header">
                <div className="header-content">
                    <button className="back-button" onClick={() => navigate(-1)}>
                        <Icon>arrow_back</Icon>
                    </button>
                    <h1 className="header-title">Form Observasi</h1>
                    <div className="header-spacer"></div>
                </div>
            </header>

            <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", maxWidth: "800px", margin: "0 auto", paddingBottom: "80px" }}>
                <CustomModal
                    visible={modalVisible}
                    onClose={() => setModalVisible(false)}
                    title={modalProps.title}
                    message={modalProps.message}
                    type={modalProps.type}
                    buttons={modalProps.buttons}
                />

                {/* Progress Bar */}
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px", position: "relative" }}>
                    <div style={{ position: "absolute", top: "50%", left: "0", right: "0", height: "4px", backgroundColor: "#e0e0e0", zIndex: 0 }}></div>
                    <div style={{
                        position: "absolute",
                        top: "50%",
                        left: "0",
                        width: step === 1 ? "0%" : step === 2 ? "33%" : step === 3 ? "66%" : "100%",
                        height: "4px",
                        backgroundColor: "#3f8fc4ff",
                        zIndex: 0,
                        transition: "width 0.3s ease"
                    }}></div>

                    {[1, 2, 3, 4].map((s) => (
                        <div key={s} style={{
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                            backgroundColor: step >= s ? "#3f8fc4ff" : "#e0e0e0",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: "bold",
                            zIndex: 1,
                            position: "relative"
                        }}>
                            {s}
                        </div>
                    ))}
                </div>

                {/* Step 1: Info Dasar */}
                {step === 1 && (
                    <div className="card" style={styles.card}>
                        <h4>Langkah 1: Informasi Umum</h4>

                        <div style={styles.inputGroup}>
                            <label>Lokasi *</label>
                            <input
                                type="text"
                                name="lokasi"
                                value={formData.lokasi}
                                onChange={handleInputChange}
                                placeholder="Masukkan lokasi observasi"
                                style={styles.input}
                            />
                        </div>
                        <div style={styles.inputGroup}>
                            <label>Department *</label>
                            <input
                                type="text"
                                name="department"
                                value={formData.department}
                                onChange={handleInputChange}
                                placeholder="Masukkan department"
                                style={styles.input}
                            />
                        </div>
                        <div style={styles.inputGroup}>
                            <label>Tanggal *</label>
                            <input
                                type="date"
                                name="tanggal"
                                value={formData.tanggal}
                                onChange={handleInputChange}
                                style={styles.input}
                            />
                        </div>
                        <div style={styles.inputGroup}>
                            <label>Kegiatan *</label>
                            <input
                                type="text"
                                name="kegiatan"
                                value={formData.kegiatan}
                                onChange={handleInputChange}
                                placeholder="Jenis kegiatan yang diobservasi"
                                style={styles.input}
                            />
                        </div>
                        <div style={styles.inputGroup}>
                            <label>Nama Observer *</label>
                            <input
                                type="text"
                                name="observerName"
                                value={formData.observerName}
                                onChange={handleInputChange}
                                placeholder="Nama observer"
                                style={styles.input}
                            />
                        </div>
                        <div style={styles.inputGroup}>
                            <label>Nama Yang Diobservasi *</label>
                            <input
                                type="text"
                                name="observedPersonName"
                                value={formData.observedPersonName}
                                onChange={handleInputChange}
                                placeholder="Nama orang yang diobservasi"
                                style={styles.input}
                            />
                        </div>
                    </div>
                )}

                {/* Step 2: Observation Checklist */}
                {step === 2 && (
                    <div>
                        <div style={{ marginBottom: "10px", fontWeight: "bold" }}>Langkah 2: Checklist Observasi</div>

                        {/* Tab Navigation */}
                        <div style={{ display: "flex", gap: "5px", marginBottom: "15px", flexWrap: "wrap" }}>
                            {observationSections.map((section, idx) => (
                                <button
                                    key={section.id}
                                    onClick={() => setActiveTab(idx)}
                                    style={{
                                        padding: "10px 15px",
                                        backgroundColor: activeTab === idx ? "#3f8fc4ff" : "#e0e0e0",
                                        color: activeTab === idx ? "white" : "#333",
                                        border: "none",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                        fontSize: "12px",
                                        fontWeight: activeTab === idx ? "bold" : "normal",
                                        flex: "1",
                                        minWidth: "120px"
                                    }}
                                >
                                    {section.title}
                                </button>
                            ))}
                        </div>

                        {/* Active Section Questions */}
                        <div className="card" style={{ ...styles.card, borderTop: "4px solid #2196f3" }}>
                            <h4 style={{ marginTop: 0, color: "#1976d2", borderBottom: "1px solid #eee", paddingBottom: "10px", fontWeight: "bold" }}>
                                {observationSections[activeTab].title}
                            </h4>

                            {observationSections[activeTab].questions.map((q) => {
                                const response = formData.responses[q.no] || {};
                                return (
                                    <div key={q.no} style={{ marginBottom: "15px", borderBottom: "1px solid #f5f5f5", paddingBottom: "10px" }}>
                                        <p style={{ margin: "0 0 10px 0", fontSize: "14px" }}>
                                            <strong style={{ color: "#2196f3" }}>{q.no}</strong> {q.text}
                                        </p>
                                        <div style={{ display: "flex", gap: "15px", flexWrap: "wrap", alignItems: "center" }}>
                                            <label style={{ cursor: "pointer", display: "flex", alignItems: "center" }}>
                                                <input
                                                    type="radio"
                                                    name={`q-${q.no}`}
                                                    checked={response.jawaban === "Safe"}
                                                    onChange={() => handleResponseChange(q.no, "Safe")}
                                                    style={{ marginRight: "5px" }}
                                                />
                                                <span style={{ color: "#4caf50", fontWeight: "bold" }}>Safe</span>
                                            </label>
                                            <label style={{ cursor: "pointer", display: "flex", alignItems: "center" }}>
                                                <input
                                                    type="radio"
                                                    name={`q-${q.no}`}
                                                    checked={response.jawaban === "Unsafe"}
                                                    onChange={() => handleResponseChange(q.no, "Unsafe")}
                                                    style={{ marginRight: "5px" }}
                                                />
                                                <span style={{ color: "#f44336", fontWeight: "bold" }}>Unsafe</span>
                                            </label>
                                            {response.jawaban && (
                                                <button
                                                    onClick={() => handleResponseChange(q.no, response.jawaban)}
                                                    style={{
                                                        background: "none",
                                                        border: "none",
                                                        cursor: "pointer",
                                                        color: "#9e9e9e",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        padding: "5px"
                                                    }}
                                                >
                                                    <Icon style={{ fontSize: "20px" }}>highlight_off</Icon>
                                                </button>
                                            )}
                                        </div>

                                        {/* Conditional Keterangan for Unsafe */}
                                        {response.jawaban === "Unsafe" && (
                                            <div style={{ marginTop: "10px", padding: "10px", backgroundColor: "#ffebee", borderRadius: "5px" }}>
                                                <label style={{ fontSize: "12px", color: "#f44336", display: "block", marginBottom: "5px" }}>
                                                    ⚠️ Keterangan (wajib untuk Unsafe) *
                                                </label>
                                                <textarea
                                                    value={response.keterangan || ""}
                                                    onChange={(e) => handleKeteranganChange(q.no, e.target.value)}
                                                    placeholder="Jelaskan kondisi unsafe yang ditemukan..."
                                                    style={{ ...styles.input, minHeight: "60px", resize: "vertical" }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}

                {/* Step 3: Findings, Recommendations & Comments */}
                {step === 3 && (
                    <div className="card" style={styles.card}>
                        <h4>Langkah 3: Temuan & Rekomendasi</h4>

                        {/* Actions (Uraian Tindakan) */}
                        <div style={{ marginBottom: "20px" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                                <label style={{ fontWeight: "bold" }}>Uraian Tindakan</label>
                                <button onClick={addAction} style={{ ...styles.button, backgroundColor: "#2196f3", padding: "5px 10px", fontSize: "12px" }}>
                                    + Tambah
                                </button>
                            </div>
                            {formData.actions.map((action, idx) => (
                                <div key={idx} style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                                    <input
                                        type="text"
                                        value={action.description}
                                        onChange={(e) => updateAction(idx, e.target.value)}
                                        placeholder={`Tindakan ${idx + 1}`}
                                        style={{ ...styles.input, flex: 1 }}
                                    />
                                    {formData.actions.length > 1 && (
                                        <button
                                            onClick={() => removeAction(idx)}
                                            style={{ ...styles.button, backgroundColor: "#ff5252", padding: "10px 15px" }}
                                        >
                                            ×
                                        </button>
                                    )}
                                </div>
                            ))}
                        </div>

                        {/* Recommendations */}
                        <div style={{ marginBottom: "20px" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                                <label style={{ fontWeight: "bold" }}>Rekomendasi Tindakan</label>
                                <button onClick={addRecommendation} style={{ ...styles.button, backgroundColor: "#2196f3", padding: "5px 10px", fontSize: "12px" }}>
                                    + Tambah
                                </button>
                            </div>
                            {formData.recommendations.map((rec, idx) => (
                                <div key={idx} style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                                    <input
                                        type="text"
                                        value={rec.description}
                                        onChange={(e) => updateRecommendation(idx, e.target.value)}
                                        placeholder={`Rekomendasi ${idx + 1}`}
                                        style={{ ...styles.input, flex: 1 }}
                                    />
                                    {formData.recommendations.length > 1 && (
                                        <button
                                            onClick={() => removeRecommendation(idx)}
                                            style={{ ...styles.button, backgroundColor: "#ff5252", padding: "10px 15px" }}
                                        >
                                            Hapus
                                        </button>
                                    )}
                                </div>
                            ))}
                        </div>

                        {/* Supervisor Comment */}
                        <div style={styles.inputGroup}>
                            <label>Komentar Supervisor</label>
                            <textarea
                                name="supervisorComment"
                                value={formData.supervisorComment}
                                onChange={handleInputChange}
                                placeholder="Komentar dari supervisor..."
                                style={{ ...styles.input, minHeight: "80px", resize: "vertical" }}
                            />
                        </div>

                        {/* Supervisor Name */}
                        <div style={styles.inputGroup}>
                            <label>Nama Supervisor *</label>
                            <input
                                type="text"
                                name="supervisorName"
                                value={formData.supervisorName}
                                onChange={handleInputChange}
                                placeholder="Nama supervisor"
                                style={styles.input}
                            />
                        </div>
                    </div>
                )}

                {/* Step 4: Tanda Tangan */}
                {step === 4 && (
                    <div className="card" style={styles.card}>
                        <h4>Langkah 4: Tanda Tangan</h4>

                        {/* Summary */}
                        <div style={{ backgroundColor: "#e3f2fd", padding: "15px", borderRadius: "8px", marginBottom: "20px" }}>
                            <h5 style={{ margin: "0 0 10px 0", color: "#1976d2" }}>Ringkasan Laporan</h5>
                            <div style={{ fontSize: "14px" }}>
                                <div style={{ display: "flex", marginBottom: "5px" }}>
                                    <span style={{ color: "#666", width: "120px" }}>Lokasi:</span>
                                    <span>{formData.lokasi}</span>
                                </div>
                                <div style={{ display: "flex", marginBottom: "5px" }}>
                                    <span style={{ color: "#666", width: "120px" }}>Department:</span>
                                    <span>{formData.department}</span>
                                </div>
                                <div style={{ display: "flex", marginBottom: "5px" }}>
                                    <span style={{ color: "#666", width: "120px" }}>Tanggal:</span>
                                    <span>{formData.tanggal}</span>
                                </div>
                                <div style={{ display: "flex", marginBottom: "5px" }}>
                                    <span style={{ color: "#666", width: "120px" }}>Observer:</span>
                                    <span>{formData.observerName}</span>
                                </div>
                                <div style={{ display: "flex", marginBottom: "5px" }}>
                                    <span style={{ color: "#666", width: "120px" }}>Diobservasi:</span>
                                    <span>{formData.observedPersonName}</span>
                                </div>
                            </div>
                        </div>

                        {/* Response Stats */}
                        <div style={{ display: "flex", gap: "10px", justifyContent: "center", marginBottom: "20px" }}>
                            <div style={{ textAlign: "center", padding: "10px 20px", backgroundColor: "#e8f5e9", borderRadius: "8px", flex: 1 }}>
                                <div style={{ fontSize: "24px", fontWeight: "bold", color: "#4caf50" }}>{stats.safe}</div>
                                <div style={{ fontSize: "12px", color: "#666" }}>Safe</div>
                            </div>
                            <div style={{ textAlign: "center", padding: "10px 20px", backgroundColor: "#ffebee", borderRadius: "8px", flex: 1 }}>
                                <div style={{ fontSize: "24px", fontWeight: "bold", color: "#f44336" }}>{stats.unsafe}</div>
                                <div style={{ fontSize: "12px", color: "#666" }}>Unsafe</div>
                            </div>
                        </div>



                        {/* Observer Signature */}
                        <div style={{ marginBottom: "20px" }}>
                            <label style={{ display: "block", marginBottom: "10px", fontWeight: "bold" }}>Tanda Tangan Observer</label>
                            <div style={{ border: "1px solid #ddd", borderRadius: "8px", overflow: "hidden" }}>
                                <canvas
                                    ref={observerCanvasRef}
                                    width={350}
                                    height={150}
                                    style={{ width: "100%", height: "150px", cursor: "crosshair", touchAction: "none" }}
                                    onMouseDown={(e) => startDrawing(e, observerCanvasRef)}
                                    onMouseMove={(e) => draw(e, observerCanvasRef)}
                                    onMouseUp={() => stopDrawing(observerCanvasRef, 'observerSignature')}
                                    onMouseLeave={() => stopDrawing(observerCanvasRef, 'observerSignature')}
                                    onTouchStart={(e) => startDrawing(e, observerCanvasRef)}
                                    onTouchMove={(e) => draw(e, observerCanvasRef)}
                                    onTouchEnd={() => stopDrawing(observerCanvasRef, 'observerSignature')}
                                />
                            </div>
                            <button
                                onClick={() => clearSignature(observerCanvasRef, 'observerSignature')}
                                style={{ ...styles.button, backgroundColor: "#ff5252", padding: "5px 10px", fontSize: "12px", marginTop: "5px" }}
                            >
                                Hapus
                            </button>
                        </div>

                        {/* Observed Person Signature */}
                        <div style={{ marginBottom: "20px" }}>
                            <label style={{ display: "block", marginBottom: "10px", fontWeight: "bold" }}>Tanda Tangan Yang Diobservasi</label>
                            <div style={{ border: "1px solid #ddd", borderRadius: "8px", overflow: "hidden" }}>
                                <canvas
                                    ref={observedCanvasRef}
                                    width={350}
                                    height={150}
                                    style={{ width: "100%", height: "150px", cursor: "crosshair", touchAction: "none" }}
                                    onMouseDown={(e) => startDrawing(e, observedCanvasRef)}
                                    onMouseMove={(e) => draw(e, observedCanvasRef)}
                                    onMouseUp={() => stopDrawing(observedCanvasRef, 'observedSignature')}
                                    onMouseLeave={() => stopDrawing(observedCanvasRef, 'observedSignature')}
                                    onTouchStart={(e) => startDrawing(e, observedCanvasRef)}
                                    onTouchMove={(e) => draw(e, observedCanvasRef)}
                                    onTouchEnd={() => stopDrawing(observedCanvasRef, 'observedSignature')}
                                />
                            </div>
                            <button
                                onClick={() => clearSignature(observedCanvasRef, 'observedSignature')}
                                style={{ ...styles.button, backgroundColor: "#ff5252", padding: "5px 10px", fontSize: "12px", marginTop: "5px" }}
                            >
                                Hapus
                            </button>
                        </div>
                    </div>
                )}

                {/* Footer Buttons */}
                <div style={{ marginTop: "20px", display: "flex", justifyContent: "space-between" }}>
                    {step > 1 ? (
                        <button onClick={prevStep} style={{ ...styles.button, backgroundColor: "#757575" }} disabled={isSubmitting}>Kembali</button>
                    ) : (
                        <button onClick={() => navigate("/laporan-safety")} style={{ ...styles.button, backgroundColor: "#757575" }}>Batal</button>
                    )}

                    {step < 4 ? (
                        <button onClick={nextStep} style={{ ...styles.button, backgroundColor: "#4caf50" }}>Lanjut</button>
                    ) : (
                        <button
                            onClick={handleSubmit}
                            style={{ ...styles.button, backgroundColor: isSubmitting ? "#9e9e9e" : "#2196f3" }}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? "Menyimpan..." : "Submit"}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}

const styles = {
    card: {
        backgroundColor: "#f3f2f2ff",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        marginBottom: "20px"
    },
    inputGroup: {
        marginBottom: "15px"
    },
    input: {
        width: "100%",
        padding: "10px",
        borderRadius: "5px",
        border: "1px solid #ddd",
        boxSizing: "border-box"
    },
    button: {
        padding: "10px 20px",
        color: "white",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        fontSize: "14px"
    }
};
